/* screens/crm/LeadFormDrawer.jsx — создание лида вручную.
   Клиент — единственное обязательное поле. Контакты (email/телефон/Telegram/
   WhatsApp/MAX) и доп. поля воронки — необязательны. Лид падает в указанный
   этап (presetStageId) или во входной этап воронки. */
import React from 'react';
import { Drawer } from '../../components/ui/Drawer.jsx';
import { Button } from '../../components/ui/Button.jsx';
import { Field, NativeSelect, NumberInput, TextInput } from '../../components/ui/Field.jsx';
import { Select } from '../../components/ui/Select.jsx';
import { useToast } from '../../app/providers/ToastProvider.jsx';
import { CustomFields } from './CustomFields.jsx';
import * as crm from '../../lib/api/crm.js';

const { useState } = React;

function LeadFormDrawer({ pipelineId, presetStageId, sources, staff = [], customFields = [], currentUser, onClose, onCreated }) {
  const toast = useToast();
  const [form, setForm] = useState({
    client: '', company: '', email: '', phone: '', telegram: '', whatsapp: '', max: '',
    source: 'manual', source_detail: '', value: '',
  });
  const [custom, setCustom] = useState({});
  const [ownerId, setOwnerId] = useState(currentUser?.id ? String(currentUser.id) : '');
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');

  const setField = (k) => (v) => { setForm((f) => ({ ...f, [k]: v })); setErr(''); };

  const submit = async () => {
    if (!form.client.trim()) { setErr('Укажите клиента.'); return; }
    setSaving(true);
    try {
      const body = {
        pipeline: pipelineId,
        client: form.client.trim(),
        company: form.company,
        email: form.email, phone: form.phone,
        telegram: form.telegram, whatsapp: form.whatsapp, max: form.max,
        source: form.source, source_detail: form.source_detail,
        value: form.value === '' ? null : form.value,
        custom_fields: custom,
      };
      if (presetStageId) body.stage = presetStageId;
      if (ownerId) body.owner = Number(ownerId);
      const lead = await crm.createLead(body);
      toast.show('Лид создан', 'accent');
      onCreated && onCreated(lead);
    } catch (e) {
      setErr(e?.detail || 'Не удалось создать лид.');
      setSaving(false);
    }
  };

  const footer = (
    <>
      <Button variant="ghost" onClick={onClose} disabled={saving}>Отмена</Button>
      <div className="grow" />
      <Button variant="primary" loading={saving} onClick={submit}>Создать лид</Button>
    </>
  );

  return (
    <Drawer open onClose={onClose} size="md" title="Новый лид" footer={footer}>
      <div className="stack stack-12">
        <Field label="Клиент" error={err} required hint="ФИО или название — единственное обязательное поле.">
          <TextInput value={form.client} onChange={(e) => setField('client')(e.target.value)} invalid={!!err}
            placeholder="Например: Иван Петров / Кафе «Уют»" autoFocus />
        </Field>
        <Field label="Компания">
          <TextInput value={form.company} onChange={(e) => setField('company')(e.target.value)} />
        </Field>

        <div className="crm-section-label">Контакты</div>
        <div className="crm-grid2">
          <Field label="Email">
            <TextInput type="email" value={form.email} onChange={(e) => setField('email')(e.target.value)} />
          </Field>
          <Field label="Телефон">
            <TextInput value={form.phone} onChange={(e) => setField('phone')(e.target.value)} />
          </Field>
          <Field label="Telegram">
            <TextInput value={form.telegram} onChange={(e) => setField('telegram')(e.target.value)} placeholder="@username" />
          </Field>
          <Field label="WhatsApp">
            <TextInput value={form.whatsapp} onChange={(e) => setField('whatsapp')(e.target.value)} />
          </Field>
          <Field label="MAX">
            <TextInput value={form.max} onChange={(e) => setField('max')(e.target.value)} />
          </Field>
        </div>

        {customFields.length > 0 && (
          <>
            <div className="crm-section-label">Дополнительно</div>
            <CustomFields defs={customFields} values={custom} onChange={setCustom} />
          </>
        )}

        <div className="crm-section-label">Сделка</div>
        <div className="crm-grid2">
          <Field label="Источник">
            <NativeSelect value={form.source} onChange={(e) => setField('source')(e.target.value)} options={sources} />
          </Field>
          <Field label="Источник (детально)">
            <TextInput value={form.source_detail} onChange={(e) => setField('source_detail')(e.target.value)} placeholder="лендинг, звонок…" />
          </Field>
          <Field label="Сумма">
            <NumberInput value={form.value} onChange={setField('value')} unit="₽" min={0} />
          </Field>
          <Field label="Ответственный">
            <Select value={ownerId} onChange={setOwnerId}
              options={[{ value: '', label: '— Не назначен —' },
                ...staff.map((u) => ({ value: String(u.id), label: u.full_name }))]}
              placeholder="Не назначен" searchable={staff.length > 6} />
          </Field>
        </div>
      </div>
    </Drawer>
  );
}

export { LeadFormDrawer };
